import { IBizAutoLogResponse } from '../type/btm-biz';
import { BTMEventType } from '../type/btm-core';

// 缓存到 localstorage 的 cache key
export const BTM_TIMESTAMP_PRE = '$btm_ts_pre_xafgobhjy';
export const BTM_ACTION_BTM_PRE = '$btm_ab_pre_mgujlufnf';

/**
 * 判断是否为合法的点位：
 * 严格模式，也就是由 a-d 开头，后面接 4 个数字这种
 * 非严格模式
 * @param code btm 点位
 */
export const isValidCode = (code: string, strict = true) => {
  // 如果能精准匹配，目前只允许 3-9 位数字
  if (/^[a-d][0-9]{3,9}$/.test(code)) {
    return true;
  }

  // 如果非严格模式，尝试也用 a0、b0 这种形式去匹配一下
  if (!strict) {
    return /^[a-d]0$/.test(code);
  }

  return false;
};

/**
 * @param fullCode btm 字符串
 * @param codeType 点位类型，包括 a，b，c，d 四类点位
 * @param exact 是否严格匹配，如果为 true，不会匹配 a0，b0 这种点位
 * @returns 返回对应点位的合法点位，没有则不返回
 */
export const getBtmCode = (fullCode: string, codeType: 'a' | 'b' | 'c' | 'd', strict = true) => {
  try {
    const btmArr = String(fullCode)
      .split('.')
      .map((btm) => btm.toLowerCase());
    const res = btmArr.find((btm) => btm.startsWith(codeType) && isValidCode(btm, strict));
    return res;
  } catch (err) {
    console.error(err);
  }
};

export const EmptyBizLogResponse: IBizAutoLogResponse = {
  onBizFail: () => {
    //
  },
  onBizSucceed: () => {
    //
  }
};

// 进行 biz 请求和 action_btm 匹配时，允许两者之间出现的最大时间差
export const BIZ_ACTION_MAX_TS_GAP = 10 * 1000;

// 最多保留 action_btm 上报记录个数
export const HISTORY_MAX_LEN = 10;

/** 是否吻合方法，如果是标准点位，使用相等判断，否则使用正则判断 */
export const matchBtmCode = (btm: string, btmToMatch: string) => {
  const btmCodes = btm.split('.');
  const lastCode = btmCodes[btmCodes.length - 1];
  if (!isValidCode(lastCode, false)) {
    const reg = btm.includes('${index}') ? new RegExp(btm.replace('${index}', '(\\d+)')) : new RegExp(btm);
    return reg.test(btmToMatch);
  } else {
    return btm === btmToMatch;
  }
};

export function isValidBTM(btm: string, eventName: string) {
  const parts = btm.split('.');
  if (parts.length === 4) {
    const cPoint = parts[2];
    const dPoint = parts[3];
    if (eventName === BTMEventType.Click && cPoint === 'c0' && dPoint === 'd0') {
      console.error('BTM 点击事件格式错误', btm);
      return false;
    }
    if (eventName === BTMEventType.ModuleShow && cPoint === 'c0' && dPoint === 'd0') {
      console.error('BTM 曝光事件格式错误', btm);
      return false;
    }
  }
  return true;
}

// for 导航栏等场景
export function isByPassValidate(type: 'click' | 'expose' | 'pageShow' | 'disappear', btm: string) {
  if (type === 'click' || type === 'expose') {
    const arr = btm.split('.');
    if (arr.length === 4) {
      return true;
    }
  }
  return false;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6IiIsIm5hbWVzIjpbXSwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXX0=